import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Single axios instance for the new NestJS backend. `withCredentials: true`
// makes the browser attach our httpOnly auth cookies on every request and
// honor `Set-Cookie` on responses.
//
// 401-retry interceptor: try /auth/refresh once. On further failure, mint a
// fresh anonymous session so the SPA always has *some* identity. This mirrors
// the legacy Firebase pattern where every visitor has a currentUser.
export const apiClient = axios.create({
  baseURL,
  withCredentials: true,
});

let refreshing = null;

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err?.config;
    if (!original || original._retryCount >= 1 || err?.response?.status !== 401) {
      return Promise.reject(err);
    }

    // Don't recurse on the auth endpoints themselves — let their 401s through
    // so the caller can react (e.g. fall back to bootstrapSession()).
    const url = original.url || '';
    if (url.startsWith('/auth/refresh') || url.startsWith('/auth/anonymous')) {
      return Promise.reject(err);
    }

    original._retryCount = (original._retryCount ?? 0) + 1;

    refreshing =
      refreshing ||
      apiClient
        .post('/auth/refresh')
        .catch(() => apiClient.post('/auth/anonymous'))
        .finally(() => {
          refreshing = null;
        });

    try {
      await refreshing;
    } catch {
      return Promise.reject(err);
    }

    return apiClient(original);
  },
);
